import { Button } from "@studyplus/boron-ui";
import * as React from "react";
import styles from "./styles.scss";

interface DeleteButtonProps {
  submitting: boolean;
  onDelete: () => void;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  submitting,
  onDelete,
}) => {
  return (
    <Button
      disabled={submitting}
      type="button"
      onClick={onDelete}
      className={styles.delete_button}
    >
      削除
    </Button>
  );
};
